function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.844 22.998l23.437 23.19L74.156 4",
  stroke: "#fff",
  strokeWidth: 7.055,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 50,
    viewBox: "0 0 78 50",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzgiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA3OCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuODQzNzUgMjIuOTk4M0wyNy4yODEyIDQ2LjE4NzVMNzQuMTU2MiA0IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjcuMDU1MjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=";
export { SvgCheckMark as ReactComponent };